import React, { useRef } from 'react';
import Slider from '@App/common/components/Slider/Slider';
import Container from '@Theme/natucare/components/Container/Container';
import Button from '@Theme/natucare/components/Button/Button';
import SlideItem from './components/SlideItem/SlideItem';
import * as styles from './TestimonialsVideo.module.scss';
const TestimonialsVideo = ({
  heading,
  subheading,
  actions,
  slides
}) => {
  var _actions$button, _actions$button2;
  if (!heading && !slides && !actions) {
    return null;
  }
  const youtubePopupContainerRef = useRef();
  const config = {
    type: 'carousel',
    perView: 5,
    gap: 16,
    breakpoints: {
      768: {
        perView: 3,
        gap: 8
      }
    }
  };
  return /*#__PURE__*/React.createElement("section", {
    className: `${styles.root} ${styles.rootWave} ${styles.rootWhite}`
  }, /*#__PURE__*/React.createElement(Container, {
    classname: styles.rootContainer
  }, subheading && /*#__PURE__*/React.createElement("div", {
    className: styles.rootSubheadingWrapper
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.rootSubheading,
    dangerouslySetInnerHTML: {
      __html: subheading
    }
  })), heading && /*#__PURE__*/React.createElement("h2", {
    className: styles.rootHeading,
    dangerouslySetInnerHTML: {
      __html: heading
    }
  }), /*#__PURE__*/React.createElement(Slider, {
    config: config,
    classname: styles.rootSlider,
    slides: slides.map((el, index) => /*#__PURE__*/React.createElement(SlideItem, Object.assign({}, el, {
      youtubePopupContainerRef: youtubePopupContainerRef,
      key: index
    })))
  }), (actions === null || actions === void 0 ? void 0 : actions.button) && /*#__PURE__*/React.createElement(Button, {
    label: actions === null || actions === void 0 ? void 0 : (_actions$button = actions.button) === null || _actions$button === void 0 ? void 0 : _actions$button.label,
    href: actions === null || actions === void 0 ? void 0 : (_actions$button2 = actions.button) === null || _actions$button2 === void 0 ? void 0 : _actions$button2.href,
    variant: "secondaryOrange",
    classname: styles.rootButton
  }), /*#__PURE__*/React.createElement("div", {
    ref: youtubePopupContainerRef
  })));
};
export default TestimonialsVideo;